module.exports = "/static/assets/d7938d9353ddf22816aca9a861a6ac74.gif";